import { prependPathWithParams } from '@dhl/utils'
import { dashboardLinks, type DashboardLinks } from './dashboard/view/links.js'
import { locatorLinks, type LocatorLinks } from './locator/links.js'
import { type MoreLinks, moreLinks } from './more/view/links.js'
import { piecesLinks, type PiecesLinks } from './pieces/view/links.js'
import { type ProfileLinks, profileLinks } from './profile/view/links.js'
import { searchLinks, type SearchLinks } from './search/view/links.js'
import { setupLinks, type SetupLinks } from './setup/links.js'
import { trackTraceLinks, type TrackTraceLinks } from './tracktrace/links.js'
import { c2cLinks, type C2CLinks } from './c2c/view/links.js'
import { dhlExtraLinks, type DhlExtraLinks } from './profile/view/dhl-extra/view/links.js'
import { interventionLinks, type InterventionLinks } from './intervention/view/links.js'
import { type ServicepointsLinks, servicepointsLinks } from './servicepoints/links.js'

export const paths = {
  DASHBOARD: 'dashboard',
  PROFILE: 'profile',
  PIECES: 'shipments',
  INTERVENTIONS: 'interventions',
  TRACKTRACE: 'tracktrace',
  DHL_EXTRA: 'extra',
  LOCATOR: 'locator',
  MORE: 'more',
  SEARCH: 'search',
  SETUP: 'setup',
  C2C: 'c2c',
  SERVICEPOINTS: 'servicepoints',
}

export const externalPaths = {
  PWA: 'pwa/shipment/package',
  ACCOUNT: 'account',
  PASSWORD_RESET: 'account/recovery',
}

const externalLinks = {
  pwaLink: () => `/${externalPaths.PWA}`,
  accountLink: () => `/${externalPaths.ACCOUNT}?referrer=portal`,
  passwordResetLink: () => `/${externalPaths.PASSWORD_RESET}`,
}

type ExternalLinks = typeof externalLinks

export const links: Links = {
  ...prependPathWithParams(() => paths.DASHBOARD, dashboardLinks),
  ...prependPathWithParams(() => paths.MORE, moreLinks),
  ...prependPathWithParams(() => paths.LOCATOR, locatorLinks),
  ...prependPathWithParams(() => paths.DHL_EXTRA, dhlExtraLinks),
  ...prependPathWithParams(() => paths.PIECES, piecesLinks),
  ...prependPathWithParams(() => paths.C2C, c2cLinks),
  ...prependPathWithParams(() => paths.PROFILE, profileLinks),
  ...prependPathWithParams(() => paths.SEARCH, searchLinks),
  ...prependPathWithParams(() => paths.SETUP, setupLinks),
  ...prependPathWithParams(() => paths.TRACKTRACE, trackTraceLinks),
  ...prependPathWithParams(() => paths.INTERVENTIONS, interventionLinks),
  ...prependPathWithParams(() => paths.SERVICEPOINTS, servicepointsLinks),
  rootLink: () => '/',
  ...externalLinks,
}

type Links = DashboardLinks &
  MoreLinks &
  LocatorLinks &
  PiecesLinks &
  C2CLinks &
  DhlExtraLinks &
  ProfileLinks &
  SearchLinks &
  SetupLinks &
  TrackTraceLinks &
  InterventionLinks &
  ServicepointsLinks &
  ExternalLinks & {
    rootLink: () => string
  }
